const URL_BASE=process.env.REACT_APP_API;

//export const URL_PENDINGS=`${URL_BASE}/financial/payments/pending`;
//export const URL_MAKE=`${URL_BASE}/financial/payments/make`;

export const URL_SUBSCRIPTIONS=`${URL_BASE}/financial/payments/subscriptions`;
export const URL_CANCEL_SUBSCRIPTION=`${URL_BASE}/financial/payments/cancel`;